module.exports = __webpack_public_path__ + "img/title.0d7a5911.png";